import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'

import { mainApi } from './services/mainApi'
import { digitalAppApi } from './services/digitalAppApi'
import allContacts from './slices/allContacts'
import currentOrderSlice from './slices/changeOrder'
import changeItemsSlice from './slices/changeItems'
import currentProductSlice from './slices/currentProduct'
import changeContactSlice from './slices/changeContact'
import userSettingsSlice from './slices/userSettings'
import userPermissionsSlice from './slices/userPermissions'
import BLP, { setAllUiFilters } from './slices/BLP'

const listenerMiddleware = createListenerMiddleware();

const saveUiStateToLocalStorage = (uiState) => {
    const LS_KEY = 'BLP_UI_STATE';
    try {
        const serializedState = JSON.stringify(uiState);
        localStorage.setItem(LS_KEY, serializedState);
        console.log("UI State saved via listener.");
    } catch (e) {
        console.error("Could not save UI state to localStorage", e);
    }
};

listenerMiddleware.startListening({
    // match: (action) => action.type.startsWith('BLP/set'), // Можно так, чтобы слушать все экшены 'set...'
    predicate: (action, currentState, previousState) => {
        return JSON.stringify(currentState.BLP.ui) !== JSON.stringify(previousState.BLP.ui);
    },
    effect: async (action, listenerApi) => {
        const uiState = listenerApi.getState().BLP.ui;
        saveUiStateToLocalStorage(uiState);
    },
});

const combineReducers = {
  allContacts: allContacts,
  currentOrder: currentOrderSlice,
  changeItems: changeItemsSlice,
  currentProduct: currentProductSlice,
  changeContact: changeContactSlice,
  userSettings: userSettingsSlice,
  userPermissions: userPermissionsSlice,
  BLP: BLP,
  [mainApi.reducerPath]: mainApi.reducer,
  [digitalAppApi.reducerPath]: digitalAppApi.reducer,
}

export const store = configureStore({
  reducer: combineReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(mainApi.middleware)
      .concat(digitalAppApi.middleware)
      .prepend(listenerMiddleware.middleware)
})
